import '../../index.css'
import '../locale/init'

import { ApiProvider } from '@btime/react-api'
import { MessagerHandler } from '@btime/react-messager'
import { SessionHandler } from '@btime/react-session'
import { compose } from 'ramda'
import { useNavigate } from '@reach/router'
import React from 'react'

import { EnvProvider } from './EnvContext'
import { ModalsHandler } from '../../components/modals/ModalsContext'
import { NavigationProvider } from './NavigationContext'
import { ResponsiveProvider } from './ResponsiveProvider'
import { ThemeHandler } from '../../packages/kiti/components/theme/ThemeHandler'
import Env from '../env/env'
import ErrorHandler from '../../components/helpers/ErrorHandler'
import HelpProvider from './HelpProvider'
import Routes from '../routes/Routes'
import apiConfig from '../api/config'
import apis from '../api/index'
import { sessionConfig } from '../session/config'
import { TrackerProvider } from './TrackerContext'
import { NewFeatureProvider } from './NewFeature'
import { AnalyticsProvider } from '../analytics/AnalyticsProvider'

const ReactWrapper = ({ children }) => {
  const env = process.env
  const apiOptions = {
    apiUrl: process.env.REACT_APP_API_URL,
    ...apiConfig
  }
  const clarityAppId = process.env.REACT_APP_CLARITY_APP_ID

  return compose(
    children => <NewFeatureProvider children={children} />,
    children => <NavigationProvider value={useNavigate} children={children} />,
    children => <ThemeHandler children={children} />,
    children => <ModalsHandler children={children} />,
    children => <EnvProvider value={Env(env)} children={children} />,
    children => <ApiProvider value={apis} config={apiOptions} children={children} />,
    children => <ResponsiveProvider children={children} />,
    children => <MessagerHandler children={children} />,
    children => <TrackerProvider children={children} />,
    children => <SessionHandler children={children} config={sessionConfig} />,
    children => <HelpProvider children={children} />,
    children => <AnalyticsProvider children={children} appId={clarityAppId} />,
    children => <ErrorHandler children={children} />,
    children => <Routes children={children} />
  )(undefined)
}

export default ReactWrapper
